<template>
  <button
    class="whitespace-nowrap rounded"
    :class="[
      props.active ? tagColor.color : 'text-gray2',
      props.active ? tagColor.borderColor : 'border-gray1',
      props.service === 'Wabunka' ? 'border-[0.5px]' : 'border',
      props.active ? tagColor.bgColorActive : tagColor.bgColor,
      !props.active && props.hoverColor ? `md:hover:${props.hoverColor}` : '',
      widthClass,
      tagSize.fontSize,
      tagSize.lineHight,
      tagSize.height,
      paddingX,
    ]"
    :data-active="props.active"
    v-bind="$attrs"
    @click="props.onClick"
  >
    <slot></slot>
  </button>
</template>

<script lang="ts" setup>
type TagLevel = 'primary' | 'secondary' | 'tertiary';
type TagSizeKey = 'small' | 'medium' | 'large' | 'wabunkaDefault';

interface Props {
  onClick: () => void;
  active?: boolean;
  level?: TagLevel;
  size?: TagSizeKey;
  widthClass?: string;
  paddingX?: string;
  service?: 'Otonami' | 'Wabunka';
  hoverColor?: string;
}

const props = withDefaults(defineProps<Props>(), {
  active: false,
  level: 'primary',
  size: 'medium',
  widthClass: '',
  paddingX: 'px-2',
  service: 'Otonami',
  hoverColor: '',
});

interface TagColor {
  color: string;
  bgColor: string;
  bgColorActive: string;
  borderColor: string;
}

interface TagSize {
  fontSize: string;
  lineHight: string;
  height: string;
}
const tagColor = computed<TagColor>(() => {
  switch (props.service) {
    case 'Otonami':
      switch (props.level) {
        case 'primary':
          return {
            color: 'text-white',
            bgColor: 'bg-transparent',
            bgColorActive: 'bg-gold1',
            borderColor: 'border-gold1',
          };
        case 'secondary':
          return {
            color: 'text-gold1',
            bgColor: 'bg-transparent',
            bgColorActive: 'bg-beige1',
            borderColor: 'border-gray1',
          };
        case 'tertiary':
          return {
            color: 'text-gold1',
            bgColor: 'bg-transparent',
            bgColorActive: 'bg-transparent',
            borderColor: 'border-gold1',
          };
        default:
          return {
            color: 'text-white',
            bgColor: 'bg-transparent',
            bgColorActive: 'bg-gold1',
            borderColor: 'border-gold1',
          };
      }
    case 'Wabunka':
      return {
        color: 'text-gold1',
        bgColor: 'bg-white/80',
        bgColorActive: 'bg-beige1',
        borderColor: 'border-gold3',
      };
  }
});

const tagSize = computed<TagSize>(() => {
  switch (props.service) {
    case 'Otonami':
      switch (props.size) {
        case 'small':
          return {
            fontSize: 'text-[10px] md:text-xs',
            lineHight: 'leading-[14px] md:leading-[20px]',
            height: 'h-6',
          };
        case 'medium':
          return {
            fontSize: 'text-xs',
            lineHight: 'leading-[22px]',
            height: 'h-[34px]',
          };
        case 'large':
          return {
            fontSize: 'text-[15px]',
            lineHight: 'leading-[28px]',
            height: 'h-10',
          };
        default:
          return {
            fontSize: 'text-xs',
            lineHight: 'leading-[22px]',
            height: 'h-[34px]',
          };
      }
    case 'Wabunka':
      return {
        fontSize: 'text-base',
        lineHight: 'leading-[28px]',
        height: 'h-10',
      };
  }
});
</script>
